import { useState } from 'react';

import Blurhash from '../Blurhash/Blurhash.component';

import styles from './BlurhashImage.module.scss';
import { Props } from './BlurhashImage.props';

const BlurhashImage = ({ blurhash, imageUrl, width, height }: Props) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const opacity = imageLoaded ? 0 : 1;

  const onLoad = () => setImageLoaded(true);

  return (
    <div className={styles.container} style={{ width, height }}>
      <div className={styles.blurhash} style={{ opacity }}>
        <Blurhash blurhash={blurhash} width={width} height={height} />
      </div>

      <img src={imageUrl} className={styles.image} onLoad={onLoad} />
    </div>
  );
};

export default BlurhashImage;
